import $ from 'jquery';

/**
 * Village / camping filter on the property lists (.filterlink tabs and the
 * #filterstrutture <select>, filtering the .struttura cards). Used by
 * properties/show and tailored/show.
 */
export function initPropertyFilter() {
    const hasVillage = $('.struttura').is('[data-id="villaggi"]');
    const hasCamping = $('.struttura').is('[data-id="camping"]');

    if (!hasVillage) {
        $('.filterlink[data-filter="villaggi"]').hide();
    }

    if (!hasCamping) {
        $('.filterlink[data-filter="camping"]').hide();
    }

    $('.filterlink').click(function (e) {
        filterProperties($(e.target).data('filter'));
    });
    $('#filterstrutture').change(function (e) {
        filterProperties(e.target.value);
    });
    if ($('#filterstrutture').length > 0 && window.location.hash.trim() != '') {
        $("[data-filter='" + window.location.hash.slice(1) + "']").trigger('click');
    }
}

function filterProperties(value) {
    $('.filterlink').removeClass('active');
    $("[data-filter='" + value + "']").addClass('active');

    if ($('#filterstrutture').val() != value) {
        $('#filterstrutture').val(value).trigger('change');
    }

    if (value === 'all') {
        $('.struttura').fadeIn();
    } else {
        $('.struttura').each(function () {
            // data-id can hold several comma-separated values
            var ids = $(this).data('id').split(',');
            if (ids.indexOf(value) === -1) {
                $(this).fadeOut();
            } else {
                $(this).fadeIn();
            }
        });
    }
}
